import pick from 'lodash/pick';

const materialsTechDetailsPick = [
  'name',
  'quality',
  'animal',
  'composition',
  'certifications',
  'abrasionResistance',
  'pilling',
  'lightfastness',
  'flameResistance',
  'origin',
  'status',
  'tanningMethod',
  'finish',
  'thickness',
  'metal',
  'gloss',
  'ralColorReference',
  'RALName',
  'pantoneReference',
  'slug',
  'latinName',
  'manufacturer',
  'texture',
];

const formatter = new Intl.ListFormat('en', {
  style: 'long',
  type: 'conjunction',
});

const getMaterialsString = (
  arr: readonly { readonly shortTitle: string }[],
): string => {
  if (!arr) return undefined;

  const formatted = formatter.format(
    arr
      .filter((c) => !!c.shortTitle)
      .map((c) => c.shortTitle)
      .sort(),
  );

  return formatted;
};

export const getMaterialsTechDetails = (
  material: Queries.MaterialTechnicalDetailsFragment & {
    consistsOf: Queries.MaterialTechnicalDetailsFragment[];
  },
  comboMaterial = false,
) => {
  if (comboMaterial) {
    return (material?.consistsOf || []).map((nestedMaterial) =>
      pick(
        {
          slug: nestedMaterial.slug,
          name: [nestedMaterial.group, nestedMaterial.title]
            .filter(Boolean)
            .join(', '),
          ...nestedMaterial,
          certifications: getMaterialsString(nestedMaterial.certifications),
          flameResistance: getMaterialsString(nestedMaterial.flameResistance),
        },
        materialsTechDetailsPick,
      ),
    );
  }

  return [
    pick(
      {
        slug: material?.slug,
        name: [material?.group, material?.title].filter(Boolean).join(', '),
        ...material,
        certifications: getMaterialsString(material?.certifications),
        flameResistance: getMaterialsString(material?.flameResistance),
      },
      materialsTechDetailsPick,
    ),
  ];
};
